/* Size guide is shown only after Theme Editor config provides a real chart. */
(() => {
  if (window.tfSizeGuideReady) return;
  window.tfSizeGuideReady = true;
  let previousFocus = null;
  const getDialog = () => document.querySelector('dialog[data-tf-size-guide]');
  const refresh = () => {
    const dialog = getDialog();
    document.querySelectorAll('[data-tf-size-guide-open]').forEach(button => {
      button.hidden = !dialog;
      if (dialog) button.setAttribute('aria-controls', dialog.id);
      else button.removeAttribute('aria-controls');
    });
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-tf-size-guide-open]');
    if (opener) {
      const dialog = getDialog();
      if (!dialog) return;
      event.preventDefault();
      previousFocus = opener;
      if (!dialog.open) dialog.showModal();
      dialog.querySelector('[data-tf-guide-close]')?.focus();
      return;
    }
    const close = event.target.closest('[data-tf-guide-close]');
    if (close) {
      close.closest('dialog')?.close();
      return;
    }
    const dialog = event.target.closest('dialog[data-tf-size-guide]');
    if (dialog && event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  document.addEventListener('close', event => {
    if (event.target.matches('dialog[data-tf-size-guide]') && previousFocus?.isConnected) {
      previousFocus.focus();
      previousFocus = null;
    }
  }, true);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(refresh));
  const start = () => {
    refresh();
    new MutationObserver(refresh).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
